import { render, staticRenderFns } from "./entity-delete-modal-provider.vue?vue&type=template&id=1e6c9396&scoped=true&"
import script from "./entity-delete-modal-provider.ts?vue&type=script&lang=ts&"
export * from "./entity-delete-modal-provider.ts?vue&type=script&lang=ts&"
import style0 from "./entity-delete-modal-provider.scss?vue&type=style&index=0&id=1e6c9396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c9396",
  null
  
)

export default component.exports